import { Component, Input } from '@angular/core';
import { RoadOccupationStageFormValue } from '../../forms/road-occupation-stage.form';
import { CommonModule, DecimalPipe } from '@angular/common';
import { ToNumberPipe } from '../../../../../../../pipes/to-number.pipe';

@Component({
  selector: 'app-road-occupation-stage-table',
  standalone: true,
  imports: [
    CommonModule,
    DecimalPipe,
    ToNumberPipe
  ],
  templateUrl: './road-occupation-stage-table.component.html'
})
export class RoadOccupationStageTableComponent {

  @Input()
  public stage: RoadOccupationStageFormValue | null = null;

  constructor() {
  }
}
